export const ManualInventoryRouting = [
  {
    path: "/material/manual-inventory",
    name: "manual-inventory",
    meta: { title: "手动盘点" },
    component: () => import("@/views/material/manual-inventory/list/index.vue"),
  },
];